export const SET_GRAPHICS = 'DASHBOARD/SET_GRAPHICS';
export const SET_OCCUPATION = 'DASHBOARD/SET_OCCUPATION';
export const SET_CASHFLOW = 'DASHBOARD/SET_CASHFLOW';
export const SET_PAID_OUT = 'DASHBOARD/SET_PAID_OUT';
export const SET_CANCELED = 'DASHBOARD/SET_CANCELED';
export const SET_ALTERED = 'DASHBOARD/SET_ALTERED';